import { memo, FC } from "react";
import { Link, Td, Textarea, Tr } from "@chakra-ui/react";
import { EditIcon, EmailIcon, ExternalLinkIcon } from "@chakra-ui/icons";
import { PrimaryButton } from "../../atoms/button/PrimaryButton";

type Props = {
  id: string;
  description: string;
  expires: string;
  status: string;
  onClick: (id: string) => void;
};

export const OrionRegistrationRow: FC<Props> = memo((props) => {
  const {
    id,
    description,
    expires,
    status,
    onClick,
  } = props;

  return (
    <Tr key={id} bg="gray.50">
      <Td>
        <Link onClick={() => onClick(id)} isExternal>
          {id}
          <EditIcon mx="2" color={"gray"} fontSize="sm" />
        </Link>
      </Td>
      <Td>{description}</Td>
      <Td>{status}</Td>
      {/* <Td>
        <Box
          border="1px"
          p="2"
          borderColor={"gray.300"}
          dangerouslySetInnerHTML={{ __html: htmlPart }}
        ></Box>
      </Td> */}
    </Tr>
  );
});
